'use client';
import React, { useRef } from 'react';
import Div from '@pezeshk-book/ui-kit/div';
import ShowMoreComment from './show-more-comment';
import CommentForm from './comment-form';
import { CommentProps, replyHandlerProps } from './comment.props';
import { useDispatch } from 'react-redux';
import { AuthActions } from '@store/auth/auth-actions';
import Comments from './comments';

const Comment = (
  {
    list,
    showMore,
    lastPage,
    submitHandler,
    onChange,
    showMoreHandler,
    replyHandler,
    showMoreLoading,
    commentValue,
    submitLoading,
    parentName,
    currentPage,
    hasScore,
    score,
    scoreCallBack,
  }: CommentProps) => {
  // ref
  const commentRef = useRef<HTMLDivElement>(null);

  // dispatch
  const dispatch = useDispatch();

  const parentIdHandler = ({ id, name }: replyHandlerProps) => {
    replyHandler({ id, name });
    if (commentRef?.current) {
      commentRef?.current?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const loginModalHandler = () => {
    dispatch(AuthActions.setLoginModal({ loginModal: true }));
  };

  return (
    <Div className={'w-full flex-col items-center gap-4'}>
      <Comments list={list} loginHandler={loginModalHandler} replyHandler={parentIdHandler}/>
      <ShowMoreComment loading={showMoreLoading} showMore={showMore} lastPage={lastPage} currentPage={currentPage} showMoreHandler={showMoreHandler}/>
      <CommentForm
        scoreCallBack={scoreCallBack}
        hasScore={hasScore}
        score={score}
        commentValue={commentValue}
        parentName={parentName}
        submitLoading={submitLoading}
        directHandler={parentIdHandler}
        ref={commentRef}
        onChange={onChange}
        submitHandler={submitHandler}
        loginHandler={loginModalHandler}
      />
    </Div>
  );
};

export default Comment;
